import { render, staticRenderFns } from "./appDicomUpload.vue?vue&type=template&id=3742e73e&scoped=true"
import script from "./appDicomUpload.vue?vue&type=script&lang=js"
export * from "./appDicomUpload.vue?vue&type=script&lang=js"
import style0 from "./appDicomUpload.vue?vue&type=style&index=0&id=3742e73e&prod&lang=css"
import style1 from "./appDicomUpload.vue?vue&type=style&index=1&id=3742e73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742e73e",
  null
  
)

export default component.exports